module.exports = __webpack_public_path__ + "img/fond.212a9432.png";